import { render } from "./ScheduleItem.vue?vue&type=template&id=f8ff879c"
import script from "./ScheduleItem.vue?vue&type=script&lang=js"
export * from "./ScheduleItem.vue?vue&type=script&lang=js"

import "./ScheduleItem.vue?vue&type=style&index=0&id=f8ff879c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__